function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#009CA6",
  d: "M212,0h816c117.1,0,212,94.9,212,212v816c0,117.1-94.9,212-212,212H212 c-117.1,0-212-94.9-212-212V212C0,94.9,94.9,0,212,0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M1059.3,489c-3.9-7.3-9.1-13.9-15.3-19.4c-6.7-5.9-14.4-10.5-22.8-13.5 c-8.8-3.4-18.1-5.1-27.5-5.1H655.3v488h111V788.8h227.4c9.4,0,18.7-1.7,27.5-5.1c8.4-3.2,16.2-7.9,22.8-14 c6.1-5.6,11.3-12.1,15.3-19.3c3.8-6.8,5.8-14.4,5.7-22.1V511.5C1065,503.6,1063,495.9,1059.3,489z M954.5,563.5v118 c0,0.4-0.2,0.8-0.2,1.2c-0.7,7.8-3.4,13.3-8.2,16.5c-3.3,2.1-7.5,3.3-12.7,3.3H765.8V539.3h167.6c11.6,0,18.3,5.4,20.3,16.1 c0.1,0.8,0.3,1.5,0.4,2.4c0,0.2,0,0.5,0.1,0.8c0.1,1.4,0.3,2.8,0.3,4.3L954.5,563.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M285.4,451h-50.7c-7.7,0-15.4,1.7-22.3,5.1c-7.1,3.4-13.6,8.2-18.9,14.1 c-1,1.1-1.8,2.4-2.7,3.6c-9.8,11.2-15,24.7-15.6,40.5c-0.1,1.1-0.2,2.1-0.2,3.2v208.1c0,9,1.7,17.8,5.2,26.1 c0.4,0.8,0.8,1.6,1.2,2.4c0.6,1.3,1.2,2.5,1.9,3.8c2.7,5.4,6.1,10.5,10.2,15c5.3,5.9,11.7,10.7,18.9,14.1c7.1,3.4,15.4,6.6,23.2,6.6 h251.6v34.5c0,15-7.5,22.6-22.6,22.6H287.4V939h243.8c18.6,0,34.5-5.1,47.5-15.4c13-10.3,19.5-24.8,19.5-43.4V451H285.4z  M486.8,601.3v78.6c0,15.5-6.9,23.9-20.7,23.9l-67.6,0h-90.5c-13.8,0-20.6-6.3-20.6-21.8V564c0-15.5,6.9-23.3,20.6-23.3h158 c13.8,0,20.7,7.8,20.7,23.3L486.8,601.3z"
});

function SvgAppIconProceqGprLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1240 1240",
    style: {
      enableBackground: "new 0 0 1240 1240"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconProceqGprLive);
export default __webpack_public_path__ + "static/media/appIconProceqGPRLive.62a6065f.svg";
export { ForwardRef as ReactComponent };